import React from 'react';
import {useSelector} from 'react-redux';
import {selectPhase, selectWarPhaseStage} from '../../redux/reducers/sharedStateReducer/selectors';
import {PHASES, WAR_PHASE_STAGES} from '../../constants/phases';
import './WarPhaseStagesPanel.css';
import {getWarPhaseStageIcon} from "../../utils/phase/getWarPhaseStageIcon";
import {getWarPhaseStageName} from "../../utils/phase/getWarPhaseStageName";
import {EngravedIcon} from "../gameUi/EngravedIcon";
import {joinClassNames} from "../gameUi/joinClassNames";

const stagesOrder = [
  WAR_PHASE_STAGES.RECRUITMENT,
  WAR_PHASE_STAGES.MOVEMENT,
  WAR_PHASE_STAGES.ABILITIES,
  WAR_PHASE_STAGES.SHOOTING,
  WAR_PHASE_STAGES.COMBAT,
  WAR_PHASE_STAGES.MANEUVER,
];

/**
 * Этапы фазы войны — строка иконок в центральной плашке шапки (HeaderPhaseZone),
 * текущий выделен. Отдельного лотка под шапкой нет: шапка в войне не растет.
 * Вне войны не рендерится
 */
const WarPhaseStagesPanel = ({className}) => {
  const phase = useSelector(selectPhase);
  const currentStage = useSelector(selectWarPhaseStage);

  if (phase !== PHASES.WAR) {
    return null;
  }

  return (
    <ol
      className={joinClassNames('war-phase-stages', className)}
      aria-label={'Этапы войны'}
      // Число ячеек — для их сжатия в тесной шапке (HeaderPhaseZone.css)
      style={{'--war-stages-count': stagesOrder.length}}
    >
      {stagesOrder.map((stage) => (
        <li
          key={stage}
          className={joinClassNames('war-phase-stages_stage', stage === currentStage && 'war-phase-stages_stage_current')}
          title={getWarPhaseStageName(stage)}
          aria-current={stage === currentStage ? 'step' : undefined}
        >
          <EngravedIcon
            src={getWarPhaseStageIcon(stage)}
            size={stage === WAR_PHASE_STAGES.MANEUVER ? 21 : 19}
            alt={getWarPhaseStageName(stage)}
          />
        </li>
      ))}
    </ol>
  );
};

export default WarPhaseStagesPanel;
